export default __webpack_public_path__ + "static/media/mobile_step_1_Hk.4aa037de.jpg";